import { defineStore } from "pinia";

export const useServiceNow = defineStore("serviceNow", {
  state: () => ({
    visible: false,
  }),
  actions: {
    setVisible(value) {
      this.visible = value;
    },
  },
});
